import React, { useState } from 'react';
import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { validatePassword } from '../Validation/validation';
import { useParams } from 'react-router-dom';
import { changePasswordByAuth } from './profileApi';
import { useSnackbar } from '../../../Context/SnackbarContext';


interface ProfileChangePasswordProps {
  onClose: () => void;
  userNum: number; // Required userData prop
}

const ProfileChangePassword: React.FC<ProfileChangePasswordProps> = ({ onClose, userNum }) => {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState<{ [key: string]: string }>({})
  const { tenant } = useParams<{ tenant: string }>()
  const { showSnackbar } = useSnackbar();


  const handleSave = async () => {
    const newErrors: { [key: string]: string } = {};
    if (currentPassword.trim().length === 0) {
      newErrors.currentpassword = 'Please fill this field.';
    }
    if (!validatePassword(newPassword)) {
      newErrors.newpassword = 'Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.'
    }
    if (newPassword !== confirmPassword) {
      newErrors.confirmpassword = 'Passwords do not match.'
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
    }


    try {
      const payLoad = {
        CurrentPassword: currentPassword,
        NewPassword: confirmPassword
      }
      const response = await changePasswordByAuth(tenant, payLoad)
      if (response) {
        setCurrentPassword('')
        setNewPassword('')
        setConfirmPassword('')
        showSnackbar("Password changed successfully.","success");
        onClose()
      } else {
        setErrors({ currentpassword: 'Invalid current password. Please try again.' });
      }
    } catch (error) {
      showSnackbar("Failed to change password.Please try again.","error");
      console.log(error)
    }

  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} flex={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Change your password
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Current Password"
            type="password"
            variant="outlined"
            value={currentPassword}
            onChange={(e) => { 
              setCurrentPassword(e.target.value)
              setErrors((prevErrors)=>(
                {
                  ...prevErrors,
                  currentpassword:''
                }
              ))  
            }}
            error={!!errors.currentpassword}
            helperText={errors.currentpassword}
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="New Password"
            type="password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => { 
              setNewPassword(e.target.value)
              setErrors((prevErrors)=>(
                {
                  ...prevErrors,
                  newpassword:''
                }
              )) 
            }}
            error={!!errors.newpassword}
            helperText={errors.newpassword}
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Confirm Password"
            type="password"
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => { 
              setConfirmPassword(e.target.value)
              setErrors((prevErrors)=>(
                {
                  ...prevErrors,
                  confirmpassword:''
                }
              ))  
            }}
            error={!!errors.confirmpassword}
            helperText={errors.confirmpassword}
            autoComplete='off'
          />
        </Grid>
      </Grid>

      {/* Save Button at the Bottom */}
      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            mb: 2
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </Box>
    </Box>

  );
};

export default ProfileChangePassword;
